// Copyright (c) 2021 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { executorMutation, Init, notificationService } from "../../../app/rpc"
import { AckNotificationRequestSchema, AckNotificationResponse } from "../../../generated/wisetime/user/notification/v4/notification_pb"

type ListNotificationsRpc = (request: Init<typeof AckNotificationRequestSchema>) => Observable<AckNotificationResponse>

export const ackNotification = (ackNotificationRpc: ListNotificationsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.ackNotification.match),
      mergeMap(action => ackNotificationRpc(action.payload).pipe(
        mergeMap(response => {
          const actions: Action[] = [
            Slice.removeNotification(action.payload.notificationId ?? ""),
          ]
          const url = response.openUrl
          if (url) {
            actions.push(Actions.redirectToUrl(url))
          }
          return concat(actions)
        }),
        catchError(_ => of(Actions.ackNotificationFailed())),
      )),
    )

const ackNotificationRpc = (request: Init<typeof AckNotificationRequestSchema>): Observable<AckNotificationResponse> =>
  executorMutation(() => notificationService.ackNotification(create(AckNotificationRequestSchema, request)))

export default ackNotification(ackNotificationRpc)
